var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flow-container',{attrs:{"children":_vm.tpl.children}})}
var staticRenderFns = []

export { render, staticRenderFns }